import React, { Component, PropTypes } from 'react';
import cn from 'classnames';
import _ from 'lodash';
import moment from 'moment';

import { connect } from 'react-redux';
import classes from '../styles/teacher/TeacherRevenue.module.scss';
import formateDate from 'utils/formatDate';
import { TableHelper } from 'helpers/Table';

import { Icon, RevenueList } from 'components';
import { getTeacherRevenue, getTeacherRevenueList } from 'data/teacher';
import { Menu, Table, Button, Row, Col, Spin, Select, Radio, Carousel, Alert, Input, Form, Pagination, Badge } from 'antd';
import { formatNumber, getOrganicRevenue } from 'utils/formatting';
import { Link } from 'react-router';
import { ResponsiveContainer, BarChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Bar } from 'recharts';
import Utils from 'utils/utils';
import { formatPvCode } from 'utils/formatting';

const pageLimit = 20;

const formatPrice = (number) => {
  return formatNumber(number, '0,0.00');
};

class TeacherRevenue extends Component {
  static defaultProps = {
    teacher: {},
    revenue: {},
  };

  constructor() {
    super();
    this.state = {
      transferredOpen: false,
      transactionsOpen: false,
      display: 'list',
      loading: false,
      orderItems: [],
      page: 1,
      revenue: {},
    };
  }

  componentDidMount = async () => {
    // const orderItems = await getTeacherRevenueList(this.props.teacher._id);
    this.setState({ loading: true });
    const revenue = await getTeacherRevenue(this.props.teacher._id);
    this.setState({ revenue, loading: false });
  };

  renderCustomTooltip(tooltipObj) {
    return (
      <div className={cn('recharts-default-tooltip', classes.tooltipContainer)}>
        <p className="recharts-tooltip-label">{tooltipObj.label}</p>
        <div className="recharts-tooltip-item-list">
          <div className="recharts-tooltip-item">
            <span className={cn(classes.tooltipValue)}>{formatPrice(_.get(tooltipObj, 'payload[0].value'))}</span>
          </div>
        </div>
      </div>
    );
  }

  renderChart() {
    const {
      revenue: { recentMonths },
    } = this.state;
    const data = _.map(recentMonths, (revenueObj) => {
      const newMoment = moment();

      return {
        name: formateDate(newMoment.year(revenueObj.year).month(revenueObj.month - 1), {}, 'MMM YYYY'),
        revenue: _.round(revenueObj.revenue, 2),
      };
    });
    return (
      <ResponsiveContainer height={400}>
        <BarChart data={data}>
          <XAxis dataKey="name" />
          <YAxis tickFormatter={(tick) => formatNumber(tick)} width={100} />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip content={this.renderCustomTooltip} />
          <Bar dataKey="revenue" fill="#ff902e" maxBarSize={40} />
        </BarChart>
      </ResponsiveContainer>
    );
  }

  onChangePage = async (page) => {
    this.setState({
      loading: true,
    });
    const revenue = await getTeacherRevenue(this.props.teacher._id, { page: page });
    this.setState({
      revenue,
      page,
      loading: false,
    });
    window.scroll(0, 0);
  };

  onReload = async () => {
    const orderItems = await getTeacherRevenueList(this.props.teacher._id, this.getCurrentQuery());
    this.setState({
      orderItems,
    });
  };

  onTableChange = (a, b, sorter) => {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onReload);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onReload);
    }
  };

  getCurrentQuery() {
    return {
      page: this.state.page || 1,
      sortBy: this.state.sortBy,
    };
  }

  columns = [
    {
      ...TableHelper.dateColumn('Sche.\nEnd\nDate', 'createdAt'),
      render: (notVal, record) => {
        const value = _.get(record, 'schedule.end');
        if (!value) return '';
        return moment(value).format('DD/MM/YYYY');
      },
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Class', 'class.name'),
      render: (value, record) => <Link to={`/class/${record.class._id}`}>{value}</Link>,

      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Sche. No.', 'schedule.code'),
      render: (value, record) => (
        <div>
          <Link to={`/class/${record.class._id}/schedule/${record.schedule._id}`}>{value} </Link>
          {record.schedule.remark && <Icon type="pushpin" />}
        </div>
      ),
      sorter: true,
    },
    {
      ...TableHelper.priceColumn("Teacher's\nRev", 'organicRevenue'),
      render: (value, record) => formatPrice(getOrganicRevenue(record)),
    },
    {
      ...TableHelper.priceColumn('Payout', 'teacherRevenue'),
    },
    {
      ...TableHelper.defaultColumn('Tran.\nStatus', 'withdrawal.status'),
      render: (value, record) => {
        if (value) {
          return _.startCase(value);
        } else if (record.isFreeze === true) {
          return 'Held';
        }
        return '';
      },
      sorter: true,
    },
    {
      ...TableHelper.datetimeColumn('Tran.\nDate', 'withdrawal.approvedDate'),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('%Com\nFee', 'schedule.serviceFeePercentage.normal'),
      render: (value, record) => (value ? <span>{`${_.get(record, 'schedule.serviceFeePercentage.normal')}% / ${_.get(record, 'schedule.serviceFeePercentage.repeat')}%`}</span> : ''),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('%Com\nDisc', 'schedule.feeDiscount'),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Withdrawal\nCode', 'withdrawal.code'),
      render: (value, record) => {
        return value ? (
          <Link to={`/withdraw/${record.withdrawal._id}`}>
            <span>{Utils.FormatNumberLength(value, 6)} </span>
          </Link>
        ) : (
          ''
        );
      },
    },
  ];

  renderContentTable() {
    // const orderItems = (this.state.orderItems.results || []).map((orderItem, key) => {
    //   orderItem.key = key;
    //   return orderItem;
    // });
    const transactions = this.state.revenue.transactions;
    console.log(transactions);
    if (!transactions) {
      return <div></div>;
    }

    return (
      <div>
        <Table columns={this.columns} dataSource={transactions.results} bordered pagination={false} onRowClick={this.onClickRow} onChange={this.onTableChange} scroll={{ x: 1400 }} />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={transactions.count} />
      </div>
    );
  }

  render() {
    return (
      <div>
        <Spin tip="Loading" size="large" spinning={!!this.state.loading}>
          <div className={cn('content')}>
            <div>
              <div className={classes.displayContainer}>
                <span className={cn({ [classes.active]: this.state.display === 'list' }, 'pointer')} onClick={() => this.setState({ display: 'list' })}>
                  Revenue List
                </span>{' '}
                |{' '}
                <span className={cn({ [classes.active]: this.state.display === 'summary' }, 'pointer')} onClick={() => this.setState({ display: 'summary' })}>
                  Revenue Summary Chart
                </span>
              </div>
              <Row>
                <Col sm={24}>
                  {this.state.display === 'list' && <div className={cn(classes.transactions)}>{this.renderContentTable()}</div>}
                  {this.state.display === 'summary' && <div className={cn(classes.chartHolder)}>{this.renderChart()}</div>}
                </Col>
              </Row>
            </div>
          </div>
        </Spin>
      </div>
    );
  }
}
export default connect((state) => ({}), {})(Form.create()(TeacherRevenue));
